const wrapCellStyle = {
    maxWidth: '0',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
};

export const selfHealedObjectColumns: any = [
    {
        display_name: "Application Name",
        key: "applicationName",
        headerStyles: {
            background: "#7593F2",
            color: 'white',
            width: '13%',
            padding: '0px 10px !important'
        },
        cellStyles: { ...wrapCellStyle }
    },
    {
        display_name: "Page Name",
        key: "pageName",
        headerStyles: {
            background: "#7593F2",
            color: 'white',
            width: '13%'
        },
        cellStyles: { ...wrapCellStyle }
    },
    {
        display_name: "UI Object Name",
        key: "uiObjectName",
        headerStyles: {
            background: "#7593F2",
            color: 'white',
            width: '13%'
        },
        cellStyles: { ...wrapCellStyle }
    },
    {
        display_name: "Type",
        key: "type",
        _config: {
            type: 'image_with_text',
            textStyle: 'display: none',
            prefixImage: {
                targetKey: 'type',
                values: {
                    chrome:  'assets/images/virtusa-icons/chrome.svg',
                    Chrome:  'assets/images/virtusa-icons/chrome.svg',
                    CHROME:  'assets/images/virtusa-icons/chrome.svg',
                    firefox: 'assets/images/virtusa-icons/firefox.svg',
                    Firefox: 'assets/images/virtusa-icons/firefox.svg',
                    FIREFOX: 'assets/images/virtusa-icons/firefox.svg',
                    edge:    'assets/images/virtusa-icons/edge.svg',
                    Edge:    'assets/images/virtusa-icons/edge.svg',
                    EDGE:    'assets/images/virtusa-icons/edge.svg',
                },
                styles: {
                    chrome:  'height: 16px; margin-right: 6px;',
                    Chrome:  'height: 16px; margin-right: 6px;',
                    CHROME:  'height: 16px; margin-right: 6px;',
                    firefox: 'height: 16px; margin-right: 6px;',
                    Firefox: 'height: 16px; margin-right: 6px;',
                    FIREFOX: 'height: 16px; margin-right: 6px;',
                    edge:    'height: 16px; margin-right: 6px;',
                    Edge:    'height: 16px; margin-right: 6px;',
                    EDGE:    'height: 16px; margin-right: 6px;',
                }
            }
        },
        headerStyles: {
            background: "#7593F2",
            color: 'white',
            width: '10%'
        },
        cellStyles: { ...wrapCellStyle }
    },
    {
        display_name: "Existing Object Locator",
        key: "oldLocator",
        headerStyles: {
            background: "#7593F2",
            color: 'white',
            width: '20%'
        },
        cellStyles: { ...wrapCellStyle }
    },
    {
        display_name: "Self-healed Object Locator",
        key: "newLocator",
        headerStyles: {
            background: "#7593F2",
            color: 'white',
            width: '20%'
        },
        cellStyles: { ...wrapCellStyle }
    },
    {
      display_name: "",
      key: "map",
      _config: {
        type: 'button',
        name: 'Update',
        savedName: 'Updated',
        classNames: 'btn-accello-tertiary'
      },
      headerStyles: {
        background: "#7593F2",
        width: '15%'
      }
    }
];